import React, { createContext, useContext } from 'react'
import { useForm } from 'react-hook-form'
import { B2CSignUpFormSchema, B2CSignUpFormPaymentSchema } from './schema'
import { yupResolver } from '@hookform/resolvers/yup'

// Create form context
const FormContext = createContext()

const ACCOUNT_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  confirmEmail: '',
  password: '',
  acceptTerms: false
}

const PAYMENT_VALUES = {
  country: '',
  address1: '',
  city: '',
  state: '',
  postcode: ''
}

export const useFormContext = () => useContext(FormContext)

export const FormProvider = ({ children }) => {
  const personalInfoForm = useForm({
    mode: 'onTouched',
    resolver: yupResolver(B2CSignUpFormSchema),
    defaultValues: {
      ...ACCOUNT_VALUES
    }
  })

  const paymentForm = useForm({
    mode: 'onChange',
    resolver: yupResolver(B2CSignUpFormPaymentSchema),
    defaultValues: {
      ...PAYMENT_VALUES
    }
  })

  return (
    <FormContext.Provider
      value={{
        personalInfoForm,
        paymentForm
      }}
    >
      {children}
    </FormContext.Provider>
  )
}
